import ClipboardJS from 'clipboard';

$(() => {
  // eslint-disable-next-line no-new
  new ClipboardJS('[data-clipboard-target], [data-clipboard-text]');
});
